import { BASE_URL } from '../components/AppConfig';
import { getBearerToken } from '../utils/authToken';
import { transactionsQuery } from '../pages/Payments/paymentsModel';

const statusCodeOf = (res) => String(res?.statusCode || res?.status_code || '');

const authFetch = async (path, options = {}) => {
  const token = getBearerToken();
  if (!token) {
    return { status_code: '50000', statusCode: '50000', message: 'Not authenticated' };
  }

  const { headers: optionHeaders, ...rest } = options;

  try {
    const response = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      ...rest,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: token,
        ...(optionHeaders || {}),
      },
    });

    const data = await response.json().catch(() => ({}));
    const code = data?.status_code ?? data?.statusCode;
    if (!response.ok && (data == null || code == null)) {
      return {
        status_code: '50000',
        statusCode: '50000',
        message: data?.message || `Request failed (${response.status})`,
        httpStatus: response.status,
      };
    }

    return {
      ...data,
      statusCode: data.statusCode ?? data.status_code,
      status_code: data.status_code ?? data.statusCode,
      httpStatus: response.status,
    };
  } catch {
    return { status_code: '50000', statusCode: '50000', message: 'Request failed' };
  }
};

export const isPaymentsApiSuccess = (res) => statusCodeOf(res) === '10000';

export const getPaymentsSummary = () => authFetch('/admin/payments/summary');

export const listPaymentTransactions = (params) =>
  authFetch(`/admin/payments/transactions?${transactionsQuery(params)}`);

export const getPaymentTransaction = (id) =>
  authFetch(`/admin/payments/transactions/${encodeURIComponent(id)}`);

export const createDummyCheckout = (body = {}) =>
  authFetch('/admin/payments/checkout', {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const verifyDummyPayment = (payload) =>
  authFetch('/admin/payments/verify', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
